import Footer from "parts/Footer";
import Header from "parts/Header";
import React, { Component } from "react";
import GraphicSections from "./GraphicSections";

class ContentRepurposingServices extends Component {
  componentDidMount() {
    window.scrollTo(0, 0); // Scroll to the top of the page
  }

  handlePress = () => {
    const element = document.getElementById("custom-request");
    if (element) {
      element.scrollIntoView({ behavior: "smooth" });
    }
  };

  render() {
    return (
      <>
        <Header {...this.props} />

        <section className="hero sm:items-center lg:items-start sm:flex-row relative  bg-dark-theme-purple shadow-2xl discuss py-16">
          {/* Hero Section */}
          <div className="container mx-auto relative z-10 px-6 lg:px-12">
            <div className="text-center lg:text-left animate__animated animate__fadeIn">
              <h2 className="text-white text-4xl font-bold mb-6">
                Content Creation Service
              </h2>
              <p className="font-light text-xl text-gray-200 leading-relaxed mb-4 animate__animated animate__fadeIn animate__delay-1s">
                At{" "}
                <span className="text-white font-semibold">TTP TECH LLC</span>,
                we specialize in creating high-quality, engaging content that
                helps you connect with your audience. From eye-catching
                thumbnails to stunning flyers and dynamic short-form videos, we
                ensure your content stands out and drives results.
              </p>
              <p className="font-light text-xl text-gray-200 leading-relaxed mb-4 animate__animated animate__fadeIn animate__delay-2s">
                We offer professional content creation services with quick
                turnaround times, designed to fit your brand's needs. Whether
                you're looking to grow your Instagram, promote an event with a
                custom flyer, or boost your YouTube views, we’ve got you
                covered.
              </p>
              <p className="font-light text-xl text-gray-200 leading-relaxed mb-4 animate__animated animate__fadeIn animate__delay-3s">
                Here's how our process works:
              </p>

              <ol className="list-decimal list-inside text-gray-200 text-lg space-y-2 mb-8 animate__animated animate__fadeIn animate__delay-4s">
                <li>Please submit the form below with your project details.</li>
                <li>
                  Submit your payment through our secure checkout link provided
                  after submission.
                </li>
                <li>
                  You will receive a confirmation email from{" "}
                  <span className="font-semibold text-green-400">
                    info@ttptechllc.com
                  </span>
                  .
                </li>
                <li>
                  Allow 2–4 business days for your request to be completed.
                </li>
                <li>
                  During the review process, you will receive an email with your
                  draft design for feedback and revisions. We offer up to{" "}
                  <span className="font-semibold">3 revisions</span> from the
                  original order request.
                </li>
              </ol>
              <p className="font-light text-l text-gray-200 leading-relaxed mb-4 animate__animated animate__fadeIn animate__delay-5s">
                <span className="font-semibold text-red-400">Please note:</span>{" "}
                Due to the nature of our digital content creation services,{" "}
                <span className="font-semibold">
                  all sales are final and non-refundable
                </span>
                .
              </p>
              <div className="flex justify-center lg:justify-start mb-8 animate__animated animate__fadeIn animate__delay-3s">
                <button
                  className="px-8 py-3 bg-white text-gray-800 text-xl font-semibold rounded-full shadow-lg transform hover:scale-105 transition-transform duration-300"
                  type="button"
                  onClick={this.handlePress}
                >
                  Let's Discuss Your Project
                </button>
              </div>
            </div>

            {/* Services Overview */}
            <div className="flex flex-col lg:flex-row lg:space-x-12 items-center justify-center mt-12 space-y-8 lg:space-y-0">
              {/* Instagram Short-Form Content Card */}
              <div className="w-full lg:w-1/4 px-4 animate__animated animate__fadeIn animate__delay-4s">
                <div className="bg-white p-8 rounded-lg shadow-lg hover:shadow-xl hover:scale-105 transform transition-all duration-300 text-center lg:text-left">
                  <i className="fas fa-camera-retro text-3xl text-indigo-600 mb-4" />
                  <h3 className="text-xl font-semibold mb-2">
                    Short-Form Content
                  </h3>
                  <p className="text-gray-600 mb-4">
                    Get professional short-form content for your reels, youtube shorts, TikToks,
                    and stories, optimized for engagement. We transform your
                    long-form videos into attention-grabbing, high-conversion
                    clips.
                  </p>
                  <p className="text-indigo-600 mb-4">
                    <strong>Starting at $150</strong>
                  </p>
                  <p className="text-gray-600 mb-4">
                    Quick turnaround to keep your content fresh and engaging for
                    your audience.
                  </p>
                  <button
                    type="button"
                    className="bg-indigo-600 text-white px-4 py-2 rounded-full"
                    onClick={this.handlePress}
                  >
                    Get Started
                  </button>
                </div>
              </div>

              {/* Flyer Design Card */}
              <div className="w-full lg:w-1/4 px-4 animate__animated animate__fadeIn animate__delay-5s">
                <div className="bg-white p-8 rounded-lg shadow-lg hover:shadow-xl hover:scale-105 transform transition-all duration-300 text-center lg:text-left">
                  <i className="fas fa-bullhorn text-3xl text-indigo-600 mb-4" />
                  <h3 className="text-xl font-semibold mb-2">Flyer Design</h3>
                  <p className="text-gray-600 mb-4">
                    Professionally crafted flyers that communicate your message
                    effectively. Whether it’s for an event, promotion, or
                    business, we make sure your flyer stands out.
                  </p>
                  <p className="text-indigo-600 mb-4">
                    <strong>Starting at $100 per flyer</strong>
                  </p>
                  <p className="text-gray-600 mb-4">
                    Custom designs that reflect your brand’s identity and grab
                    attention.
                  </p>
                  <button
                    className="bg-indigo-600 text-white px-4 py-2 rounded-full"
                    type="button"
                    onClick={this.handlePress}
                  >
                    Get Started
                  </button>
                </div>
              </div>

              {/* YouTube Thumbnail Design Card */}
              <div className="w-full lg:w-1/4 px-4 animate__animated animate__fadeIn animate__delay-6s">
                <div className="bg-white p-8 rounded-lg shadow-lg hover:shadow-xl hover:scale-105 transform transition-all duration-300 text-center lg:text-left">
                  <i className="fas fa-image text-3xl text-indigo-600 mb-4" />
                  <h3 className="text-xl font-semibold mb-2">
                    YouTube Thumbnail Design
                  </h3>
                  <p className="text-gray-600 mb-4">
                    Custom thumbnails designed to increase click-through rates
                    and boost your views. We ensure your thumbnails are visually
                    striking and consistent with your branding.
                  </p>
                  <p className="text-indigo-600 mb-4">
                    <strong>Starting at $50 per thumbnail</strong>
                  </p>
                  <p className="text-gray-600 mb-4">
                    High-quality designs that stand out on YouTube.
                  </p>
                  <button
                    className="bg-indigo-600 text-white px-4 py-2 rounded-full"
                    type="button"
                    onClick={this.handlePress}
                  >
                    Get Started
                  </button>
                </div>
              </div>
            </div>

            <GraphicSections />

            {/* Call to Action */}
            <div className="bg-indigo-600 text-center py-16 mt-12">
              <h2 className="text-3xl text-white font-semibold mb-6">
                Ready to elevate your content?
              </h2>
              <p className="text-xl text-white mb-6">
                Let's collaborate to create marketing materials that captivate
                and convert.
              </p>
              <button
                className="px-8 py-3 bg-white text-indigo-600 text-xl font-semibold rounded-full shadow-lg transform hover:scale-105 transition-transform duration-300"
                type="button"
                onClick={this.handlePress}
              >
                Let's Talk
              </button>
            </div>
          </div>
        </section>
        <Footer />
      </>
    );
  }
}

export default ContentRepurposingServices;
